import {httpUrl} from './httpUrl'

// let baseUrl = `${httpUrl.host}/gy-apartment`
// let baseUrl85 = `${httpUrl.host}/gy-apartment`
// let baseUrl3 = `${httpUrl.host}/gy-apartment`
let baseUrl = `${httpUrl.host}/gy-finance`
let baseUrl85 = `${httpUrl.host}/gy-apartment`
let baseUrl3 = `${httpUrl.host}/gy-lease`

let api = {
  // 查询统计数据
  getDataOverview: `${baseUrl}/realTimeData/getDataOverview`,

  // 查询所有
  getAllHistoryData: `${baseUrl}/historyData/getFinance`,

  // 查询租金物业
  getLeaseHistoryData: `${baseUrl}/historyData/getLease`,

  // 查询停车费
  getParkingHistoryData: `${baseUrl}/historyData/getParking`,

  // 查询统计
  getPeriodData: `${baseUrl}/realTimeData/getPeriodData`,

  // 查询应收统计
  getPeriodReceivableData: `${baseUrl}/realTimeData/getPeriodReceivableData`,

  // 查询开票统计
  getPeriodInvoicingData: `${baseUrl}/realTimeData/getPeriodInvoicingData`,

  // 逾期未结算
  getOverdueData: `${baseUrl}/overdue/getLeaseItemsPage`,

  // 能耗费分页
  getEnergyBillPage: `${baseUrl}/enterpriseBillReport/energyBillPage`,

  // 导出逾期未结算
  exportOverdueData: `${baseUrl}/overdue/export`,

  // 修改免税状态
  updateHsbz: `${baseUrl}/payItemDetail/updateHsbz`,

  // 获取费用列表
  getPayItemDetailPage: `${baseUrl}/payItemDetail/getPage`,

  // 获取费用详情
  getPayItemDetailByCode: `${baseUrl}/payItemDetail/getByCode`,

  // 修改费用信息
  updatePayItemDetailByCode: `${baseUrl}/payItemDetail/updateByCode`,

  // 批量开票
  updatePatchPayItemDetail: `${baseUrl}/payItemDetail/updatePatch`,

  // 批量修改缴费状态
  batchPayStatus: `${baseUrl}/payItemDetail/batchPayStatus`,

  // 批量修改免税状态
  updatePatchHsbz: `${baseUrl}/payItemDetail/updatePatchHsbz`,

  // 导出物业费
  exportForRentAndProperty: `${baseUrl}/payItemDetail/exportForRentAndProperty`,

  // 导出保证金
  exportForSecurityDeposit: `${baseUrl}/payItemDetail/exportForSecurityDeposit`,

  // 账单拆分
  splitAccount: `${baseUrl}/payItemDetail/splitAccount`,

  // 分页查询收款记录
  getLeasePaymentRecordPage: `${baseUrl}/leasePaymentRecord/getPage`,

  // 添加收款记录
  addLeasePaymentRecord: `${baseUrl}/leasePaymentRecord/add`,

  // 收款记录
  getReceivePaymentPage: `${baseUrl}/receivePayment/getPage`,

  // 添加收款记录
  addReceivePayment: `${baseUrl}/receivePayment/add`,

  // 查看收款记录
  getReceivePaymentByCode: `${baseUrl}/receivePayment/getByCode`,

  // 删除收款记录
  deleteReceivePaymentByCodes: `${baseUrl}/receivePayment/deleteByCodes`,

  // 作废收款记录
  cancelReceivePaymentByCodes: `${baseUrl}/receivePayment/cancel`,

  // 收款记录关联账单
  linkBillReceivePayment: `${baseUrl}/receivePayment/linkBill`,

  // 导入收款记录
  importReceivePayment: `${baseUrl}/receivePayment/import`,

  // 导入模板下载
  uploadTemplateUrl: `https://damai-yq.oss-cn-hangzhou.aliyuncs.com/%E6%94%B6%E6%AC%BE%E8%AE%B0%E5%BD%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx`,

  // 导出收款记录
  exportReceivePayment: `${baseUrl}/receivePayment/export`,

  // 收款记录详情
  getLeasePaymentRecordByCode: `${baseUrl}/leasePaymentRecord/getByCode`,

  // 导出收款记录
  exportLeasePaymentRecord: `${baseUrl}/leasePaymentRecord/export`,

  // 根据租户查询账单列表
  getPayItemDetailListByCondition: `${baseUrl}/payItemDetail/getListByCondition`,

  // 查询账单主体列表
  getBillMainBodyList: `${baseUrl}/totalBill/mainBodyList`,

  // 根据账单主体查询账单列表
  getTotalBillList: `${baseUrl}/totalBill/list`,

  // <!--其他合约-->
  // 其他合约——账单类型
  getOtherBillTypeList: `${baseUrl3}/billType/getList`,

  // 其他合约账单查询
  getOtherPayItemDetailPage: `${baseUrl}/otherPayItemDetail/getPage`,

  // 其他合约账单导出
  exportOtherPayItemDetail: `${baseUrl}/otherPayItemDetail/exportForOtherPayDetail`,

  // 根据code查询账单
  getOtherPayItemDetailByCode: `${baseUrl}/otherPayItemDetail/getByCode`,

  // 更新账单
  updateOtherPayItemDetailByCode: `${baseUrl}/otherPayItemDetail/updateByCode`,

  // 批量修改缴费状态
  batchOtherPayItemDetailPayStatus: `${baseUrl}/otherPayItemDetail/batchPayStatus`,

  // 批量更新发票状态
  updateOtherPayItemDetailPatch: `${baseUrl}/otherPayItemDetail/updatePatch`,

  // 修改免税状态
  updateOtherPayItemDetailHsbz: `${baseUrl}/otherPayItemDetail/updateHsbz`,

  // 批量修改免税状态
  updateOtherPayItemDetailPatchHsbz: `${baseUrl}/otherPayItemDetail/updatePatchHsbz`,
  // <!--其他合约-->

  // <!--电控-->
  // 获取充值记录
  getElectricConsumptionRecord: `${baseUrl}/consumptionRecord/electric/getPage`,

  // 修改充值记录
  updateElectricConsumptionRecord: `${baseUrl}/electricConsumptionRecord/update`,

  // 批量修改充值记录
  updatePatchElectricConsumptionRecord: `${baseUrl}/electricConsumptionRecord/updatePatch`,

  // 导出充值记录
  exportElectricConsumptionRecord: `${baseUrl}/electricConsumptionRecord/export`,

  // 删除充值账户
  deleteElectricRentMoney: `${baseUrl}/electricRentMoney/deleteElectricRentMoney`,

  // 获取住户列表
  getEnterpriseList: `${baseUrl85}/enterpriseInfo/getEnterpriseList`,

  // 获取电费充值账单
  getElectricBillPage: `${baseUrl}/electricBill/getPage`,

  // 获取电费月度账单
  getElectricMonthBillPage: `${baseUrl}/electricMonthBill/getPage`,

  // 导出电费月度账单
  exportElectricMonthBill: `${baseUrl}/electricMonthBill/export`,

  // 导出房间电费月度账单
  exportElectricRoomMonthBill: `${baseUrl}/electricRoomMonthBill/export`,

  // 导入公摊电量
  importElectricMonthBill: `${baseUrl}/electricMonthBill/import`,

  // 导入房间公摊电量
  importElectricRoomMonthBill: `${baseUrl}/electricRoomMonthBill/import`,

  // 公摊电量模板下载
  electricMonthBillTemplateUrl: `https://damai-yq.oss-cn-hangzhou.aliyuncs.com/%E7%94%B5%E8%B4%B9%E6%9C%88%E5%BA%A6%E8%B4%A6%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx`,

  // 公摊电量模板下载
  electricRoomMonthBillTemplateUrl: `https://damai-gy.oss-cn-hangzhou.aliyuncs.com/template/gy_electric_month_bill_template.xlsx`,

  // 查询计费周期
  getElectricMonthBillCycle: `${baseUrl}/electricMonthBill/getCycle`,

  // 查询房间计费周期
  getElectricRoomMonthBillCycle: `${baseUrl}/electricRoomMonthBill/getCycle`,

  // 生成月结账单
  generateElectricMonthBill: `${baseUrl}/electricMonthBill/generate`,

  // 生成房间月结账单
  generateElectricRoomMonthBill: `${baseUrl}/electricRoomMonthBill/generate`,

  // 修改电费账单
  updateElectricBill: `${baseUrl}/electricBill/update`,

  // 修改月结电费账单
  updateInvoiceInfo: `${baseUrl}/electricMonthBill/updateInvoiceInfo`,

  // 修改房间月结电费账单
  updateRoomInvoiceInfo: `${baseUrl}/electricRoomMonthBill/updateInvoiceInfo`,

  // 生成电费催收单
  createElectricUrl: `${baseUrl}/electricMonthBill/createElectricUrl`,

  // 生成房间电费催收单
  createRoomElectricUrl: `${baseUrl}/electricRoomMonthBill/createElectricUrl`,

  // 批量生成电费催收单
  createPatchElectricUrl: `${baseUrl}/electricMonthBill/createPatchElectricUrl`,

  // 批量生成电费催收单
  createPatchRoomElectricUrl: `${baseUrl}/electricRoomMonthBill/createPatchElectricUrl`,

  // 获取电费月度账单
  getElectricRoomBillPage: `${baseUrl}/electricRoomMonthBill/getPage`,

  // 获取余额
  getElectricRentMoneyPage: `${baseUrl}/electricRentMoney/getRentMoneyPage`,

  // 获取房间余额
  getElectricRoomMoneyPage: `${baseUrl}/electricRoomAccount/getPage`,

  // 导出余额
  exportElectricRentMoney: `${baseUrl}/electricRentMoney/export`,

  // 导出房间余额
  exportElectricRoomMoney: `${baseUrl}/electricRoomAccount/export`,

  // 充值
  recharge: `${baseUrl}/electricRentMoney/recharge`,

  // 房间充值
  roomRecharge: `${baseUrl}/electricRoomAccount/recharge`,

  // 结算
  settlement: `${baseUrl}/electricRentMoney/settlement`,

  // 房间结算
  roomSettlement: `${baseUrl}/electricRoomAccount/settlement`,

  // 结算记录
  getSettlementPage: `${baseUrl}/electricSettlement/getPage`,
  // <!--电控-->

  // <!--水控-->
  // 获取水费账单
  getWaterBillPage: `${baseUrl}/waterBill/getPage`,

  // 获取房间水费账单
  getRoomWaterBillPage: `${baseUrl}/waterRoomMonthBill/getPage`,

  // 水费月度账单导出
  exportWaterBill: `${baseUrl}/waterBill/export`,

  // 房间水费月度账单导出
  exportRoomWaterBill: `${baseUrl}/waterRoomMonthBill/export`,

  // 修改水费账单
  updateWaterBill: `${baseUrl}/waterBill/update`,

  // 修改房间水费账单
  updateRoomWaterBill: `${baseUrl}/waterRoomMonthBill/update`,

  // 生成水费催收单
  createWaterUrl: `${baseUrl}/waterBill/createWaterUrl`,

  // 生成房间水费催收单
  createRoomWaterUrl: `${baseUrl}/waterRoomMonthBill/createWaterUrl`,

  // 批量生成水费催收单
  createPatchWaterUrl: `${baseUrl}/waterBill/createPatchWaterUrl`,

  // 水控——获取余额
  getWaterRentMoneyPage: `${baseUrl}/waterRentMoney/getRentMoneyPage`,

  // 水控——获取房间余额
  getWaterRoomMoneyPage: `${baseUrl}/waterRoomAccount/getRentMoneyPage`,

  // 水控——充值
  rechargeWaterRentMoney: `${baseUrl}/waterRentMoney/recharge`,

  // 水控——房间充值
  rechargeWaterRoomMoney: `${baseUrl}/waterRoomAccount/recharge`,

  // 水控——删除充值账户
  deleteWaterRentMoney: `${baseUrl}/waterRentMoney/deleteWaterRentMoney`,

  // 水控——结算
  waterSettlement: `${baseUrl}/waterRentMoney/settlement`,

  // 水控——房间结算
  waterRoomSettlement: `${baseUrl}/waterRoomAccount/settlement`,

  // 水控——导出余额
  exportWaterRentMoney: `${baseUrl}/waterRentMoney/export`,

  // 水控——导出房间余额
  exportWaterRoomMoney: `${baseUrl}/waterRoomAccount/export`,

  // 水控——获取充值记录
  getWaterConsumptionRecord: `${baseUrl}/consumptionRecord/water/getPage`,

  // 水控——修改充值记录
  updateWaterConsumptionRecord: `${baseUrl}/waterConsumptionRecord/update`,

  // 水控——批量修改充值记录
  updateWaterConsumptionRecordPatch: `${baseUrl}/waterConsumptionRecord/updatePatch`,

  // 水控——导出充值记录
  exportWaterConsumptionRecord: `${baseUrl}/waterConsumptionRecord/export`,

  // 水控——结算记录
  getWaterSettlementPage: `${baseUrl}/waterSettlement/getPage`,
  // <!--水控-->

  // <!--蒸汽-->
  // 获取蒸汽账单
  getSteamBillPage: `${baseUrl}/steamBill/getPage`,

  // 获取蒸汽账单
  exportSteamBill: `${baseUrl}/steamBill/export`,

  // 修改蒸汽账单
  updateSteamBill: `${baseUrl}/steamBill/update`,

  // 生成蒸汽催收单
  createSteamUrl: `${baseUrl}/steamBill/createSteamUrl`,

  // 批量生成蒸汽催收单
  createPatchSteamUrl: `${baseUrl}/steamBill/createPatchSteamUrl`,

  // 蒸汽——获取余额
  getSteamRentMoneyPage: `${baseUrl}/steamRentMoney/getRentMoneyPage`,

  // 蒸汽——充值
  rechargeSteamRentMoney: `${baseUrl}/steamRentMoney/recharge`,

  // 蒸汽——删除充值账户
  deleteSteamRentMoney: `${baseUrl}/steamRentMoney/deleteSteamRentMoney`,

  // 蒸汽——结算
  steamSettlement: `${baseUrl}/steamRentMoney/settlement`,

  // 蒸汽——导出余额
  exportSteamRentMoney: `${baseUrl}/steamRentMoney/export`,

  // 蒸汽——获取充值记录
  getSteamConsumptionRecord: `${baseUrl}/consumptionRecord/steam/getPage`,

  // 蒸汽——修改充值记录
  updateSteamConsumptionRecord: `${baseUrl}/steamConsumptionRecord/update`,

  // 蒸汽——批量修改充值记录
  updateSteamConsumptionRecordPatch: `${baseUrl}/steamConsumptionRecord/updatePatch`,

  // 蒸汽——导出充值记录
  exportSteamConsumptionRecord: `${baseUrl}/steamConsumptionRecord/export`,

  // 蒸汽——结算记录
  getSteamSettlementPage: `${baseUrl}/steamSettlement/getPage`,
  // <!--蒸汽-->

  // <!--燃气-->
  // 获取燃气账单
  getGasBillPage: `${baseUrl}/gasBill/getPage`,

  // 燃气账单导出
  exportGasBill: `${baseUrl}/gasBill/export`,

  // 修改燃气账单
  updateGasBill: `${baseUrl}/gasBill/update`,

  // 生成燃气催收单
  createGasUrl: `${baseUrl}/gasBill/createGasUrl`,

  // 批量生成燃气催收单
  createPatchGasUrl: `${baseUrl}/gasBill/createPatchGasUrl`,

  // 燃气——获取余额
  getGasRentMoneyPage: `${baseUrl}/gasRentMoney/getRentMoneyPage`,

  // 燃气——充值
  rechargeGasRentMoney: `${baseUrl}/gasRentMoney/recharge`,

  // 燃气——删除充值账户
  deleteGasRentMoney: `${baseUrl}/gasRentMoney/deleteGasRentMoney`,

  // 燃气——结算
  gasSettlement: `${baseUrl}/gasRentMoney/settlement`,

  // 燃气——导出余额
  exportGasRentMoney: `${baseUrl}/gasRentMoney/export`,

  // 燃气——获取充值记录
  getGasConsumptionRecord: `${baseUrl}/consumptionRecord/gas/getPage`,

  // 燃气——修改充值记录
  updateGasConsumptionRecord: `${baseUrl}/gasConsumptionRecord/update`,

  // 燃气——批量修改充值记录
  updateGasConsumptionRecordPatch: `${baseUrl}/gasConsumptionRecord/updatePatch`,

  // 燃气——导出充值记录
  exportGasConsumptionRecord: `${baseUrl}/gasConsumptionRecord/export`,

  // 燃气——结算记录
  getGasSettlementPage: `${baseUrl}/gasSettlement/getPage`,
  // <!--燃气-->

  // 查询包月缴费账单
  getParkingMonthBillPage: `${baseUrl}/parkingMonthBill/getPage`,

  // 修改包月账单
  updateParkingMonthBill: `${baseUrl}/parkingMonthBill/update`,

  // 导出包月账单
  exportParkingMonthBill: `${baseUrl}/parkingMonthBill/export`,

  // 查询包月缴费记录分页
  getMonthRecordPage: `${baseUrl}/consumptionRecord/parkingMonth/getPage`,

  // 导出包月缴费记录
  exportMonthRecord: `${baseUrl}/consumptionRecord/parkingMonth/export`,

  // 查询临停/提前缴费记录分页
  getTempraryRecordPage: `${baseUrl}/consumptionRecord/parkingTemporary/getPage`,

  // 导出临停/提前缴费记录
  exportTempraryRecord: `${baseUrl}/consumptionRecord/parkingTemporary/export`,

  // 获取预约账单
  getVenueBillPage: `${baseUrl}/venueBill/getPage`,

  // 修改预约账单
  updateVenueBill: `${baseUrl}/venueBill/update`,

  // 导出预约账单
  exportVenueBill: `${baseUrl}/venueBill/export`,

  // 获取预约记录分页
  getPlaceBookingPage: `${baseUrl}/consumptionRecord/placeBooking/getPage`,

  // 导出缴费记录
  exportPlaceBooking: `${baseUrl}/consumptionRecord/placeBooking/export`,

  // 获取报修账单
  getRepairBillPage: `${baseUrl}/repairBill/getPage`,

  // 修改报修账单
  updateRepairBill: `${baseUrl}/repairBill/update`,

  // 导出报修账单
  exportRepairBill: `${baseUrl}/repairBill/export`,

  // 报修缴费记录
  getRepairPayRecordPage: `${baseUrl}/consumptionRecord/repair/getPage`,

  // 导出缴费记录
  exportRepairPayRecord: `${baseUrl}/consumptionRecord/repair/export`,

  // 获取其他费用账单
  getChargeBillPage: `${baseUrl}/chargeBill/getPage`,

  // 修改其他费用账单
  updateChargeBill: `${baseUrl}/chargeBill/update`,

  // 导出其他费用账单
  exportChargeBill: `${baseUrl}/chargeBill/export`,

  // 批量修改其他账单开票状态
  batchUpdateInvoiceStatus: `${baseUrl}/chargeBill/batchUpdateInvoiceStatus`,

  // 查询通知单模板
  getTemplateList: `${baseUrl}/template/getList`,

  // 生成通知单
  createLeaseUrl: `${baseUrl}/template/createLeaseUrl`,

  // 批量生成通知单
  createPatchLeaseUrl: `${baseUrl}/template/createPatchLeaseUrl`,

  // 获取活动缴费记录分页
  getEventPage: `${baseUrl}/consumptionRecord/event/getPage`,

  // 退款管理——添加退款记录
  addRefund: `${baseUrl}/refund/add`,

  // 退款管理——确认退款
  confirmRefund: `${baseUrl}/refund/confirmRefund`,

  // 退款管理——查询退款分页
  getRefundPage: `${baseUrl}/refund/getPage`,

  // 退款管理——导出退款记录
  exportRefund: `${baseUrl}/refund/export`,

  // 水费缴费账单- 分页
  getWaterRechargeBillPage: `${baseUrl}/waterRechargeBill/getPage`,

  // 水费缴费账单-修改
  updateWaterRechargeBill: `${baseUrl}/waterRechargeBill/update`,

  // 蒸汽缴费账单- 分页
  getSteamRechargeBillPage: `${baseUrl}/steamRechargeBill/getPage`,

  // 蒸汽缴费账单-修改
  updateSteamRechargeBill: `${baseUrl}/steamRechargeBill/update`,

  // 燃气缴费账单- 分页
  getGasRechargeBillPage: `${baseUrl}/gasRechargeBill/getPage`,

  // 燃气缴费账单-修改
  updateGasRechargeBill: `${baseUrl}/gasRechargeBill/update`,

  // 公摊水量模板下载
  waterMonthBillTemplateUrl: `https://damai-yq.oss-cn-hangzhou.aliyuncs.com/water_template.xlsx`,

  // 公摊水量模板下载
  waterRoomMonthBillTemplateUrl: `https://damai-gy.oss-cn-hangzhou.aliyuncs.com/template/gy_water_month_bill_template.xlsx`,

  // 导入公摊水量
  importWaterMonthBill: `${baseUrl}/waterBill/import`,

  // 导入房间公摊水量
  importRoomWaterMonthBill: `${baseUrl}/waterRoomMonthBill/import`,

  // 查询水量计费周期
  getWaterBillCycle: `${baseUrl}/waterBill/getCycle`,

  // 查询水量计费周期
  getRoomWaterBillCycle: `${baseUrl}/waterRoomMonthBill/getCycle`,

  // 生成水量月结账单
  generateWaterMonthBill: `${baseUrl}/waterBill/generate`,

  // 生成房间水量月结账单
  generateRoomWaterMonthBill: `${baseUrl}/waterRoomMonthBill/generate`,

  //退租账单管理
  getSurrenderBillPage: `${baseUrl}/surrenderBill/getPage`,

  //租户账单管理
  getEnterpriseBillReportPage: `${baseUrl}/enterpriseBillReport/getPage`,

  //物业账单分页
  getRentBillPage: `${baseUrl}/enterpriseBillReport/rentBillPage`,

  //退租账单分页
  getSurrenderBillPagePage: `${baseUrl}/enterpriseBillReport/surrenderBillPage`,

  //租户账单导出
  exportItemDetail: `${baseUrl}/enterpriseBillReport/exportItemDetail`,

}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/Finance.js